var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-cells"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row.add_time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }